import React, { memo } from 'react'
import SharedEpicFilters from './SharedEpicFilters'
import { XProject } from '@jirax/common'

interface DateRange {
  startDate: string
  endDate: string
}

interface EpicFiltersProps {
  selectedProject: XProject | null
  dateRange: DateRange
  projects: XProject[]
  onProjectChange: (project: XProject) => void
  onDateRangeChange: (range: DateRange) => void
  loading?: boolean
  disabled?: boolean
}

const EpicFilters: React.FC<EpicFiltersProps> = memo((props) => {
  return (
    <SharedEpicFilters
      {...props}
      cardClassName="p-6 mb-6 overflow-visible"
      ariaLabelledBy="epic-filters-heading"
    />
  )
})

EpicFilters.displayName = 'EpicFilters'

export default EpicFilters